import { Container, Group, SimpleGrid, Stack, Text, Title } from '@mantine/core';
import { createFileRoute,Link } from '@tanstack/react-router';

import { MarketingShell } from '../../components/marketing/MarketingShell';
import { EXPLORATIONS } from '../../data/explorations';

export const Route = createFileRoute('/explore/')({
  component: ExploreIndex,
});

function ExploreIndex() {
  return (
    <MarketingShell>
      <Container size="lg" py="xl">
        <Stack gap="xl">
          <Stack gap="xs">
            <Text size="sm" tt="uppercase" c="brand.7" fw={600} style={{ letterSpacing: '0.1em' }}>
              Explore on WWAAVE
            </Text>
            <Title
              order={1}
              style={{
                fontFamily: 'var(--wwaave-font-display)',
                fontSize: 'clamp(2rem, 4.5vw, 3rem)',
                lineHeight: 1.1,
                letterSpacing: '-0.02em',
                fontWeight: 600,
              }}
            >
              Hand-picked views.
            </Title>
            <Text c="ink.7" size="lg" style={{ maxWidth: 720 }}>
              Cuts through the platform by city, art form, or what the host
              offers. Each view is its own page, so you can share the link directly.
            </Text>
          </Stack>

          <SimpleGrid cols={{ base: 1, sm: 2, md: 3 }} spacing="md">
            {EXPLORATIONS.map((e) => (
              <Link
                key={e.slug}
                to="/explore/$slug"
                params={{ slug: e.slug }}
                style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
              >
                <Stack
                  gap="xs"
                  p="md"
                  style={{
                    border: '1px solid var(--mantine-color-gray-3)',
                    borderRadius: 12,
                    height: '100%',
                  }}
                >
                  <Group justify="space-between">
                    <Text fw={500}>{e.title}</Text>
                  </Group>
                  <Text size="sm" c="dimmed" style={{ lineHeight: 1.5 }}>
                    {e.description}
                  </Text>
                </Stack>
              </Link>
            ))}
          </SimpleGrid>
        </Stack>
      </Container>
    </MarketingShell>
  );
}
